module.exports = __webpack_public_path__ + "img/36dc266ae9604be9427eacce1da48633.a9e7298b.jpeg";